import React, { useState, useEffect, useCallback } from 'react';
import { Box, Card, CardContent, Typography, Button, IconButton, Chip, Tabs, Tab, FormControl, InputLabel, Select, MenuItem, TextField, InputAdornment, Paper, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, TablePagination, Tooltip, Badge, Divider, Fab, List, ListItemText, ListItemIcon, ListItemSecondaryAction, Accordion, AccordionSummary, AccordionDetails, LinearProgress, CircularProgress, Alert, Menu, MenuList, MenuItem as MenuItemComponent, Switch, FormControlLabel, Dialog, DialogTitle, DialogContent, DialogActions, SelectChangeEvent, Avatar, CardMedia, CardActions, Stepper, Step, StepLabel, StepContent, Autocomplete, Checkbox, FormGroup, FormControl as MuiFormControl, FormLabel, RadioGroup, Radio, Slider, Rating, Input, OutlinedInput, InputBase} from '@mui/material';
import Grid from '@mui/material/Grid';

import {
  Business as _Business,
  MonetizationOn as _MonetizationOn,
  Schedule as _Schedule,
  MedicalServices as _MedicalServices,
  Inventory as _Inventory,
  Email as _Email,
  Security as _Security,
  Extension as _Extension,
  Gavel as _Gavel,
  History as _History,
  Settings as _Settings,
  Save as _Save,
  Refresh as _Refresh,
  Upload as _Upload,
  Download as _Download,
  Visibility as _Visibility,
  Edit as _Edit,
  Delete as _Delete,
  Add as _Add,
  ExpandMore as _ExpandMore,
  CheckCircle as _CheckCircle,
  Warning as _Warning,
  Error as _Error,
  Info as _Info,
  Lock as _Lock,
  Public as _Public,
  VpnKey as _VpnKey,
  Webhook as _Webhook,
  CloudUpload as _CloudUpload,
  CloudDownload as _CloudDownload,
  Backup as _Backup,
  Restore as _Restore,
  Shield as _Shield,
  Person as _Person,
  Phone as _Phone,
  LocationOn as _LocationOn,
  Language as _Language,
  AccessTime as _AccessTime,
  Payment as _Payment,
  Receipt as _Receipt,
  CreditCard as _CreditCard,
  AccountBalance as _AccountBalance,
  TrendingUp as _TrendingUp,
  Notifications as _Notifications,
  Sms as _Sms,
  PushPin as _PushPin,
  Computer as _Computer,
  Smartphone as _Smartphone,
  Tablet as _Tablet,
  Wifi as _Wifi,
  Bluetooth as _Bluetooth,
  Usb as _Usb,
  Memory as _Memory,
  Storage as _Storage,
  Speed as _Speed,
  NetworkCheck as _NetworkCheck,
  Router as _Router,
  Cloud as _Cloud,
  Sync as _Sync,
  Update as _Update,
  Build as _Build,
  Engineering as _Engineering,
  Science as _Science,
  Psychology as _Psychology,
  LocalHospital as _LocalHospital,
  HealthAndSafety as _HealthAndSafety,
  Biotech as _Biotech,
  Medication as _Medication,
  Vaccines as _Vaccines,
  Timeline as _Timeline,
  Assessment as _Assessment,
  Analytics as _Analytics,
  BarChart as _BarChart,
  PieChart as _PieChart,
  ShowChart as _ShowChart,
  TrendingFlat as _TrendingFlat,
  TrendingDown as _TrendingDown,
  TrendingUp as _TrendingUpIcon,
  Star as _Star,
  StarBorder as _StarBorder,
  StarHalf as _StarHalf,
  ThumbUp as _ThumbUp,
  ThumbDown as _ThumbDown,
  ThumbUpOutlined as _ThumbUpOutlined,
  ThumbDownOutlined as _ThumbDownOutlined,
  Favorite as _Favorite,
  FavoriteBorder as _FavoriteBorder,
  Bookmark as _Bookmark,
  BookmarkBorder as _BookmarkBorder,
  Flag as _Flag,
  FlagOutlined as _FlagOutlined,
  Report as _Report,
  ReportOutlined as _ReportOutlined,
  BugReport as _BugReport,
  BugReportOutlined as _BugReportOutlined,
  Help as _Help,
  HelpOutline as _HelpOutline,
  QuestionAnswer as _QuestionAnswer,
  QuestionAnswerOutlined as _QuestionAnswerOutlined,
  Support as _Support,
  SupportAgent as _SupportAgent,
  ContactSupport as _ContactSupport,
  ContactSupportOutlined as _ContactSupportOutlined,
  Feedback as _Feedback,
  FeedbackOutlined as _FeedbackOutlined,
  RateReview as _RateReview,
  RateReviewOutlined as _RateReviewOutlined,
  Reviews as _Reviews,
  ReviewsOutlined as _ReviewsOutlined,
  Comment as _Comment,
  CommentOutlined as _CommentOutlined,
  Forum as _Forum,
  ForumOutlined as _ForumOutlined,
  Chat as _Chat,
  ChatOutlined as _ChatOutlined,
  Message as _Message,
  MessageOutlined as _MessageOutlined,
  Sms as _SmsIcon,
  SmsOutlined as _SmsOutlined,
  Email as _EmailIcon,
  EmailOutlined as _EmailOutlined,
  Phone as _PhoneIcon,
  PhoneOutlined as _PhoneOutlined,
  VideoCall as _VideoCall,
  VideoCallOutlined as _VideoCallOutlined,
  VoiceChat as _VoiceChat,
  VoiceChatOutlined as _VoiceChatOutlined,
  Call as _Call,
  CallOutlined as _CallOutlined,
  CallEnd as _CallEnd,
  CallEndOutlined as _CallEndOutlined,
  CallMade as _CallMade,
  CallMadeOutlined as _CallMadeOutlined,
  CallReceived as _CallReceived,
  CallReceivedOutlined as _CallReceivedOutlined,
  CallSplit as _CallSplit,
  CallSplitOutlined as _CallSplitOutlined,
  CallMerge as _CallMerge,
  CallMergeOutlined as _CallMergeOutlined,
  CallMissed as _CallMissed,
  CallMissedOutlined as _CallMissedOutlined,
  CallMissedOutgoing as _CallMissedOutgoing,
  CallMissedOutgoingOutlined as _CallMissedOutgoingOutlined,
  Voicemail as _Voicemail,
  VoicemailOutlined as _VoicemailOutlined,
  CallMissedOutgoing as _CallMissedOutgoingIcon,
  CallMissedOutgoingOutlined as _CallMissedOutgoingOutlinedIcon,
  CallMissed as _CallMissedIcon,
  CallMissedOutlined as _CallMissedOutlinedIcon,
  CallReceived as _CallReceivedIcon,
  CallReceivedOutlined as _CallReceivedOutlinedIcon,
  CallMade as _CallMadeIcon,
  CallMadeOutlined as _CallMadeOutlinedIcon,
  CallEnd as _CallEndIcon,
  CallEndOutlined as _CallEndOutlinedIcon,
  Call as _CallIcon,
  CallOutlined as _CallOutlinedIcon,
  VoiceChat as _VoiceChatIcon,
  VoiceChatOutlined as _VoiceChatOutlinedIcon,
  VideoCall as _VideoCallIcon,
  VideoCallOutlined as _VideoCallOutlinedIcon,
  Sms as _SmsIconComponent,
  SmsOutlined as _SmsOutlinedIcon,
  Email as _EmailIconComponent,
  EmailOutlined as _EmailOutlinedIcon,
  Phone as _PhoneIconComponent,
  PhoneOutlined as _PhoneOutlinedIcon,
  Forum as _ForumIcon,
  ForumOutlined as _ForumOutlinedIcon,
  Chat as _ChatIcon,
  ChatOutlined as _ChatOutlinedIcon,
  Message as _MessageIcon,
  MessageOutlined as _MessageOutlinedIcon,
  Comment as _CommentIcon,
  CommentOutlined as _CommentOutlinedIcon,
  Reviews as _ReviewsIcon,
  ReviewsOutlined as _ReviewsOutlinedIcon,
  RateReview as _RateReviewIcon,
  RateReviewOutlined as _RateReviewOutlinedIcon,
  Feedback as _FeedbackIcon,
  FeedbackOutlined as _FeedbackOutlinedIcon,
  ContactSupport as _ContactSupportIcon,
  ContactSupportOutlined as _ContactSupportOutlinedIcon,
  Support as _SupportIcon,
  SupportAgent as _SupportAgentIcon,
  Help as _HelpIcon,
  HelpOutline as _HelpOutlineIcon,
  QuestionAnswer as _QuestionAnswerIcon,
  QuestionAnswerOutlined as _QuestionAnswerOutlinedIcon,
  BugReport as _BugReportIcon,
  BugReportOutlined as _BugReportOutlinedIcon,
  Report as _ReportIcon,
  ReportOutlined as _ReportOutlinedIcon,
  Flag as _FlagIcon,
  FlagOutlined as _FlagOutlinedIcon,
  Bookmark as _BookmarkIcon,
  BookmarkBorder as _BookmarkBorderIcon,
  Favorite as _FavoriteIcon,
  FavoriteBorder as _FavoriteBorderIcon,
  ThumbUp as _ThumbUpIcon,
  ThumbDown as _ThumbDownIcon,
  ThumbUpOutlined as _ThumbUpOutlinedIcon,
  ThumbDownOutlined as _ThumbDownOutlinedIcon,
  Star as _StarIcon,
  StarBorder as _StarBorderIcon,
  StarHalf as _StarHalfIcon,
  TrendingUp as _TrendingUpIconComponent,
  TrendingDown as _TrendingDownIcon,
  TrendingFlat as _TrendingFlatIcon,
  ShowChart as _ShowChartIcon,
  PieChart as _PieChartIcon,
  BarChart as _BarChartIcon,
  Analytics as _AnalyticsIcon,
  Assessment as _AssessmentIcon,
  Timeline as _TimelineIcon,
  Vaccines as _VaccinesIcon,
  Medication as _MedicationIcon,
  Biotech as _BiotechIcon,
  HealthAndSafety as _HealthAndSafetyIcon,
  LocalHospital as _LocalHospitalIcon,
  Engineering as _EngineeringIcon,
  Science as _ScienceIcon,
  Psychology as _PsychologyIcon,
  Build as _BuildIcon,
  Update as _UpdateIcon,
  Sync as _SyncIcon,
  Cloud as _CloudIcon,
  Router as _RouterIcon,
  NetworkCheck as _NetworkCheckIcon,
  Speed as _SpeedIcon,
  Storage as _StorageIcon,
  Memory as _MemoryIcon,
  Usb as _UsbIcon,
  Bluetooth as _BluetoothIcon,
  Wifi as _WifiIcon,
  Tablet as _TabletIcon,
  Smartphone as _SmartphoneIcon,
  Computer as _ComputerIcon,
  PushPin as _PushPinIcon,
  Sms as _SmsIconFinal,
  Notifications as _NotificationsIcon,
  TrendingUp as _TrendingUpIconFinal,
  AccountBalance as _AccountBalanceIcon,
  CreditCard as _CreditCardIcon,
  Receipt as _ReceiptIcon,
  Payment as _PaymentIcon,
  AccessTime as _AccessTimeIcon,
  Language as _LanguageIcon,
  LocationOn as _LocationOnIcon,
  Phone as _PhoneIconFinal,
  Person as _PersonIcon,
  Shield as ShieldIcon,
  Restore as RestoreIcon,
  Backup as BackupIcon,
  CloudDownload as CloudDownloadIcon,
  CloudUpload as CloudUploadIcon,
  Webhook as _WebhookIcon,
  VpnKey as _VpnKeyIcon,
  Public as _PublicIcon,
  Lock as _LockIcon,
  Info as _InfoIcon,
  Error as _ErrorIcon,
  Warning as _WarningIcon,
  CheckCircle as _CheckCircleIcon,
  ExpandMore as ExpandMoreIcon,
  Add as AddIcon,
  Delete as DeleteIcon,
  Edit as EditIcon,
  Visibility as VisibilityIcon,
  Download as DownloadIcon,
  Upload as UploadIcon,
  Refresh as RefreshIcon,
  Save as SaveIcon,
  Settings as SettingsIcon,
  History as HistoryIcon,
  Gavel as GavelIcon,
  Extension as ExtensionIcon,
  Security as SecurityIcon,
  Email as EmailIconFinal,
  Inventory as InventoryIcon,
  MedicalServices as MedicalServicesIcon,
  Schedule as ScheduleIcon,
  MonetizationOn as MonetizationOnIcon,
  Business as BusinessIcon
} from '@mui/icons-material';

import { useAuth } from '@contexts/AuthContext';
import { clinicSettingsService, ClinicInfo, FinancialSettings, AppointmentSettings, ServiceSettings, StockSettings, CommunicationSettings, PermissionSettings, IntegrationSettings, GDPRSettings, AuditLog, AuditLogFilters } from '@services/clinicSettingsService';
import { formatForDisplay, formatDateOnly, formatTimeOnly } from '@utils/dateFormatter';

interface TabPanelProps {
  children?: React.ReactNode;
  index: number;
  value: number;
}

function TabPanel(props: TabPanelProps) {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`settings-tabpanel-${index}`}
      aria-labelledby={`settings-tab-${index}`}
      {...other}
    >
      {value === index && (
        <Box sx={{ p: 3 }}>
          {children}
        </Box>
      )}
    </div>
  );
}

const InternalSettings: React.FC = () => {
  const { user } = useAuth();
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState<string | null>(null);
  const [success, setSuccess] = useState<string | null>(null);
  const [activeTab, setActiveTab] = useState(0);

  // Setari
  const [financialSettings, setFinancialSettings] = useState<FinancialSettings | null>(null);
  const [appointmentSettings, setAppointmentSettings] = useState<AppointmentSettings | null>(null);
  const [serviceSettings, setServiceSettings] = useState<ServiceSettings | null>(null);
  const [stockSettings, setStockSettings] = useState<StockSettings | null>(null);
  const [communicationSettings, setCommunicationSettings] = useState<CommunicationSettings | null>(null);
  const [permissionSettings, setPermissionSettings] = useState<PermissionSettings | null>(null);
  const [integrationSettings, setIntegrationSettings] = useState<IntegrationSettings | null>(null);
  const [gdprSettings, setGdprSettings] = useState<GDPRSettings | null>(null);

  // Audit log
  const [auditLogs, setAuditLogs] = useState<AuditLog[]>([]);
  const [auditFilters, setAuditFilters] = useState<AuditLogFilters>({});
  const [auditPage, setAuditPage] = useState(0);
  const [auditRowsPerPage, setAuditRowsPerPage] = useState(10);
  const [auditTotal, setAuditTotal] = useState(0);

  // Dialogs
  const [testDialogOpen, setTestDialogOpen] = useState(false);
  const [backupDialogOpen, setBackupDialogOpen] = useState(false);
  const [restoreDialogOpen, setRestoreDialogOpen] = useState(false);
  const [testingIntegration, setTestingIntegration] = useState<string | null>(null);

  // Incarcare setari
  const loadSettings = useCallback(async () => {
    if (!user?.clinicId) return;
    
    setLoading(true);
    setError(null);
    
    try {
      const [
        financial,
        appointments,
        services,
        stock,
        communication,
        permissions,
        integrations,
        gdpr
      ] = await Promise.all([
        clinicSettingsService.getFinancialSettings(user.clinicId),
        clinicSettingsService.getAppointmentSettings(user.clinicId),
        clinicSettingsService.getServiceSettings(user.clinicId),
        clinicSettingsService.getStockSettings(user.clinicId),
        clinicSettingsService.getCommunicationSettings(user.clinicId),
        clinicSettingsService.getPermissionSettings(user.clinicId),
        clinicSettingsService.getIntegrationSettings(user.clinicId),
        clinicSettingsService.getGDPRSettings(user.clinicId)
      ]);

      setFinancialSettings(financial);
      setAppointmentSettings(appointments);
      setServiceSettings(services);
      setStockSettings(stock);
      setCommunicationSettings(communication);
      setPermissionSettings(permissions);
      setIntegrationSettings(integrations);
      setGdprSettings(gdpr);
    } catch (err) {
      console.error('Error loading settings:', err);
      setError('Eroare la incarcarea setarilor');
    } finally {
      setLoading(false);
    }
  }, [user?.clinicId]);

  // Incarcare audit logs
  const loadAuditLogs = useCallback(async () => {
    if (!user?.clinicId) return;
    
    try {
      const data = await clinicSettingsService.getAuditLogs(user.clinicId, {
        ...auditFilters,
        page: auditPage + 1,
        limit: auditRowsPerPage
      });
      
      setAuditLogs(data.logs);
      setAuditTotal(data.total);
    } catch (err) {
      console.error('Error loading audit logs:', err);
    }
  }, [user?.clinicId, auditFilters, auditPage, auditRowsPerPage]);

  useEffect(() => {
    loadSettings();
  }, [loadSettings]);

  useEffect(() => {
    if (activeTab === 7) {
      loadAuditLogs();
    }
  }, [activeTab, loadAuditLogs]);

  // Handlers
  const handleTabChange = (event: React.SyntheticEvent, newValue: number) => {
    setActiveTab(newValue);
  };

  const handleSave = async (type: string, data: any) => {
    if (!user?.clinicId) return;
    
    setLoading(true);
    setError(null);
    
    try {
      switch (type) {
        case 'financial':
          await clinicSettingsService.updateFinancialSettings(user.clinicId, data);
          break;
        case 'appointments':
          await clinicSettingsService.updateAppointmentSettings(user.clinicId, data);
          break;
        case 'services':
          await clinicSettingsService.updateServiceSettings(user.clinicId, data);
          break;
        case 'stock':
          await clinicSettingsService.updateStockSettings(user.clinicId, data);
          break;
        case 'communication':
          await clinicSettingsService.updateCommunicationSettings(user.clinicId, data);
          break;
        case 'permissions':
          await clinicSettingsService.updatePermissionSettings(user.clinicId, data);
          break;
        case 'integrations':
          await clinicSettingsService.updateIntegrationSettings(user.clinicId, data);
          break;
        case 'gdpr':
          await clinicSettingsService.updateGDPRSettings(user.clinicId, data);
          break;
      }
      
      setSuccess('Setarile au fost salvate cu succes!');
      setTimeout(() => setSuccess(null), 3000);
    } catch (err) {
      console.error('Error saving settings:', err);
      setError('Eroare la salvarea setarilor');
    } finally {
      setLoading(false);
    }
  };

  const handleTestIntegration = async (integrationId: string) => {
    if (!user?.clinicId) return;
    
    setTestingIntegration(integrationId);
    try {
      await clinicSettingsService.testIntegration(user.clinicId, integrationId);
      setSuccess('Integrarea functioneaza corect!');
    } catch (err) {
      setError('Eroare la testarea integrarii');
    } finally {
      setTestingIntegration(null);
    }
  };

  const handleBackup = async () => {
    if (!user?.clinicId) return;
    
    try {
      const backup = await clinicSettingsService.backupSettings(user.clinicId);
      const blob = new Blob([JSON.stringify(backup, null, 2)], { type: 'application/json' });
      const url = URL.createObjectURL(blob);
      const a = document.createElement('a');
      a.href = url;
      a.download = `clinic-settings-backup-${new Date().toISOString().split('T')[0]}.json`;
      a.click();
      URL.revokeObjectURL(url);
      setSuccess('Backup-ul a fost descarcat cu succes!');
    } catch (err) {
      setError('Eroare la crearea backup-ului');
    }
  };

  const handleRestore = async (file: File) => {
    if (!user?.clinicId) return;
    
    try {
      const text = await file.text();
      const data = JSON.parse(text);
      await clinicSettingsService.restoreSettings(user.clinicId, data);
      setSuccess('Setarile au fost restaurate cu succes!');
      loadSettings();
    } catch (err) {
      setError('Eroare la restaurarea setarilor');
    }
  };

  return (
    <Box>
      {/* Header */}
      <Box sx={{ mb: 3 }}>
        <Typography variant="h4" gutterBottom>
          <SettingsIcon sx={{ mr: 1, verticalAlign: 'middle' }} />
          Setari Interne
        </Typography>
        <Typography variant="body1" color="text.secondary">
          Configureaza setarile tehnice si operationale ale clinicii
        </Typography>
      </Box>

      {/* Success/Error Alerts */}
      {success && (
        <Alert severity="success" sx={{ mb: 3 }} onClose={() => setSuccess(null)}>
          {success}
        </Alert>
      )}
      
      {error && (
        <Alert severity="error" sx={{ mb: 3 }} onClose={() => setError(null)}>
          {error}
        </Alert>
      )}

      {/* Tabs */}
      <Box sx={{ borderBottom: 1, borderColor: 'divider', mb: 3 }}>
        <Tabs value={activeTab} onChange={handleTabChange} aria-label="settings tabs">
          <Tab label="Financiare" icon={<MonetizationOnIcon />} iconPosition="start" />
          <Tab label="Programari" icon={<ScheduleIcon />} iconPosition="start" />
          <Tab label="Servicii" icon={<MedicalServicesIcon />} iconPosition="start" />
          <Tab label="Stoc" icon={<InventoryIcon />} iconPosition="start" />
          <Tab label="Comunicare" icon={<EmailIconFinal />} iconPosition="start" />
          <Tab label="Permisiuni" icon={<SecurityIcon />} iconPosition="start" />
          <Tab label="Integrari" icon={<ExtensionIcon />} iconPosition="start" />
          <Tab label="GDPR" icon={<GavelIcon />} iconPosition="start" />
          <Tab label="Audit Log" icon={<HistoryIcon />} iconPosition="start" />
        </Tabs>
      </Box>

      {/* Loading */}
      {loading && (
        <Box sx={{ display: 'flex', justifyContent: 'center', p: 4 }}>
          <LinearProgress sx={{ width: '100%' }} />
        </Box>
      )}

      {/* Financial Settings Tab */}
      <TabPanel value={activeTab} index={0}>
        {loading ? (
          <Box display="flex" justifyContent="center" p={4}>
            <CircularProgress />
          </Box>
        ) : financialSettings ? (
          <Grid container spacing={3}>
            <Grid size={{ xs: 12, md: 6 }}>
              <Card>
                <CardContent>
                  <Typography variant="h6" gutterBottom>
                    Setari financiare de baza
                  </Typography>
                  <Grid container spacing={2}>
                    <Grid size={{ xs: 12, sm: 6 }}>
                      <FormControl fullWidth>
                        <InputLabel>Moneda</InputLabel>
                        <Select
                          value={financialSettings?.currency || ''}
                          label="Moneda"
                          onChange={(e) => setFinancialSettings({
                            ...financialSettings, 
                            currency: e.target.value
                          })}
                        >
                          <MenuItem value="RON">RON</MenuItem>
                          <MenuItem value="EUR">EUR</MenuItem>
                          <MenuItem value="USD">USD</MenuItem>
                        </Select>
                      </FormControl>
                    </Grid>
                    <Grid size={{ xs: 12, sm: 6 }}>
                      <TextField
                        fullWidth
                        label="Cota TVA (%)"
                        type="number"
                        value={financialSettings?.taxRate || ''}
                        onChange={(e) => setFinancialSettings({
                          ...financialSettings, 
                          taxRate: parseFloat(e.target.value)
                        })}
                      />
                    </Grid>
                  </Grid>
                </CardContent>
                <CardActions>
                  <Button
                    variant="contained"
                    startIcon={<SaveIcon />}
                    onClick={() => handleSave('financial', financialSettings)}
                    disabled={loading}
                  >
                    Salveaza
                  </Button>
                </CardActions>
              </Card>
            </Grid>
          </Grid>
        ) : null}
      </TabPanel>

      {/* Appointment Settings Tab */}
      <TabPanel value={activeTab} index={1}>
        {loading ? (
          <Box display="flex" justifyContent="center" p={4}>
            <CircularProgress />
          </Box>
        ) : appointmentSettings ? (
          <Grid container spacing={3}>
            <Grid size={{ xs: 12, md: 6 }}>
              <Card>
                <CardContent>
                  <Typography variant="h6" gutterBottom>
                    Setari programari
                  </Typography>
                  <Grid container spacing={2}>
                    <Grid size={{ xs: 12, sm: 6 }}>
                      <TextField
                        fullWidth
                        label="Durata slot (minute)"
                        type="number"
                        value={appointmentSettings?.slotDuration || ''}
                        onChange={(e) => setAppointmentSettings({
                          ...appointmentSettings, 
                          slotDuration: parseInt(e.target.value)
                        })}
                      />
                    </Grid>
                    <Grid size={{ xs: 12, sm: 6 }}>
                      <TextField
                        fullWidth
                        label="Timp buffer (minute)"
                        type="number"
                        value={appointmentSettings?.bufferTime || ''}
                        onChange={(e) => setAppointmentSettings({
                          ...appointmentSettings, 
                          bufferTime: parseInt(e.target.value)
                        })}
                      />
                    </Grid>
                  </Grid>
                </CardContent>
                <CardActions>
                  <Button
                    variant="contained"
                    startIcon={<SaveIcon />}
                    onClick={() => handleSave('appointments', appointmentSettings)}
                    disabled={loading}
                  >
                    Salveaza
                  </Button>
                </CardActions>
              </Card>
            </Grid>
          </Grid>
        ) : null}
      </TabPanel>

      {/* Service Settings Tab */}
      <TabPanel value={activeTab} index={2}>
        {loading ? (
          <Box display="flex" justifyContent="center" p={4}>
            <CircularProgress />
          </Box>
        ) : serviceSettings ? (
          <Grid container spacing={3}>
            <Grid size={{ xs: 12, md: 6 }}>
              <Card>
                <CardContent>
                  <Typography variant="h6" gutterBottom>
                    Setari servicii
                  </Typography>
                  <Grid container spacing={2}>
                    <Grid size={12}>
                      <FormControlLabel
                        control={
                          <Switch
                            checked={(serviceSettings as any)?.allowOnlineBooking || false}
                            onChange={(e) => setServiceSettings({
                              ...serviceSettings,
                              allowOnlineBooking: e.target.checked
                            } as any)}
                          />
                        }
                        label="Permite rezervari online"
                      />
                    </Grid>
                    <Grid size={12}>
                      <FormControlLabel
                        control={
                          <Switch
                            checked={(serviceSettings as any)?.requireDeposit || false}
                            onChange={(e) => setServiceSettings({
                              ...serviceSettings,
                              requireDeposit: e.target.checked
                            } as any)}
                          />
                        }
                        label="Necesita avans"
                      />
                    </Grid>
                  </Grid>
                </CardContent>
                <CardActions>
                  <Button
                    variant="contained"
                    startIcon={<SaveIcon />}
                    onClick={() => handleSave('services', serviceSettings)}
                    disabled={loading}
                  >
                    Salveaza
                  </Button>
                </CardActions>
              </Card>
            </Grid>
          </Grid>
        ) : null}
      </TabPanel>

      {/* Stock Settings Tab */}
      <TabPanel value={activeTab} index={3}>
        {loading ? (
          <Box display="flex" justifyContent="center" p={4}>
            <CircularProgress />
          </Box>
        ) : stockSettings ? (
          <Grid container spacing={3}>
            <Grid size={{ xs: 12, md: 6 }}>
              <Card>
                <CardContent>
                  <Typography variant="h6" gutterBottom>
                    Setari stoc
                  </Typography>
                  <Grid container spacing={2}>
                    <Grid size={12}>
                      <FormControlLabel
                        control={
                          <Switch
                            checked={(stockSettings as any)?.lowStockAlerts || false}
                            onChange={(e) => setStockSettings({
                              ...stockSettings,
                              lowStockAlerts: e.target.checked
                            } as any)}
                          />
                        }
                        label="Alerte stoc redus"
                      />
                    </Grid>
                    <Grid size={{ xs: 12, sm: 6 }}>
                      <TextField
                        fullWidth
                        label="Prag alerta stoc"
                        type="number"
                        value={(stockSettings as any)?.lowStockThreshold || ''}
                        onChange={(e) => setStockSettings({
                          ...stockSettings,
                          lowStockThreshold: parseInt(e.target.value)
                        } as any)}
                      />
                    </Grid>
                  </Grid>
                </CardContent>
                <CardActions>
                  <Button
                    variant="contained"
                    startIcon={<SaveIcon />}
                    onClick={() => handleSave('stock', stockSettings)}
                    disabled={loading}
                  >
                    Salveaza
                  </Button>
                </CardActions>
              </Card>
            </Grid>
          </Grid>
        ) : null}
      </TabPanel>

      {/* Communication Settings Tab */}
      <TabPanel value={activeTab} index={4}>
        {loading ? (
          <Box display="flex" justifyContent="center" p={4}>
            <CircularProgress />
          </Box>
        ) : communicationSettings ? (
          <Grid container spacing={3}>
            <Grid size={{ xs: 12, md: 6 }}>
              <Card>
                <CardContent>
                  <Typography variant="h6" gutterBottom>
                    Setari comunicare
                  </Typography>
                  <Grid container spacing={2}>
                    <Grid size={12}>
                      <FormControlLabel
                        control={
                          <Switch
                            checked={(communicationSettings as any)?.emailNotifications || false}
                            onChange={(e) => setCommunicationSettings({
                              ...communicationSettings,
                              emailNotifications: e.target.checked
                            } as any)}
                          />
                        }
                        label="Notificari email"
                      />
                    </Grid>
                    <Grid size={12}>
                      <FormControlLabel
                        control={
                          <Switch
                            checked={(communicationSettings as any)?.smsNotifications || false}
                            onChange={(e) => setCommunicationSettings({
                              ...communicationSettings,
                              smsNotifications: e.target.checked
                            } as any)}
                          />
                        }
                        label="Notificari SMS"
                      />
                    </Grid>
                  </Grid>
                </CardContent>
                <CardActions>
                  <Button
                    variant="contained"
                    startIcon={<SaveIcon />}
                    onClick={() => handleSave('communication', communicationSettings)}
                    disabled={loading}
                  >
                    Salveaza
                  </Button>
                </CardActions>
              </Card>
            </Grid>
          </Grid>
        ) : null}
      </TabPanel>

      {/* Permission Settings Tab */}
      <TabPanel value={activeTab} index={5}>
        {loading ? (
          <Box display="flex" justifyContent="center" p={4}>
            <CircularProgress />
          </Box>
        ) : permissionSettings ? (
          <Grid container spacing={3}>
            <Grid size={{ xs: 12, md: 6 }}>
              <Card>
                <CardContent>
                  <Typography variant="h6" gutterBottom>
                    Setari permisiuni
                  </Typography>
                  <Grid container spacing={2}>
                    <Grid size={12}>
                      <FormControlLabel
                        control={
                          <Switch
                            checked={(permissionSettings as any)?.allowDataExport || false}
                            onChange={(e) => setPermissionSettings({
                              ...permissionSettings,
                              allowDataExport: e.target.checked
                            } as any)}
                          />
                        }
                        label="Permite exportul datelor"
                      />
                    </Grid>
                    <Grid size={12}>
                      <FormControlLabel
                        control={
                          <Switch
                            checked={(permissionSettings as any)?.allowDataImport || false}
                            onChange={(e) => setPermissionSettings({
                              ...permissionSettings,
                              allowDataImport: e.target.checked
                            } as any)}
                          />
                        }
                        label="Permite importul datelor"
                      />
                    </Grid>
                  </Grid>
                </CardContent>
                <CardActions>
                  <Button
                    variant="contained"
                    startIcon={<SaveIcon />}
                    onClick={() => handleSave('permissions', permissionSettings)}
                    disabled={loading}
                  >
                    Salveaza
                  </Button>
                </CardActions>
              </Card>
            </Grid>
          </Grid>
        ) : null}
      </TabPanel>

      {/* Integration Settings Tab */}
      <TabPanel value={activeTab} index={6}>
        {loading ? (
          <Box display="flex" justifyContent="center" p={4}>
            <CircularProgress />
          </Box>
        ) : integrationSettings ? (
          <Grid container spacing={3}>
            <Grid size={{ xs: 12, md: 6 }}>
              <Card>
                <CardContent>
                  <Typography variant="h6" gutterBottom>
                    Setari integrari
                  </Typography>
                  <Grid container spacing={2}>
                    <Grid size={12}>
                      <FormControlLabel
                        control={
                          <Switch
                            checked={(integrationSettings as any)?.anafIntegration || false}
                            onChange={(e) => setIntegrationSettings({
                              ...integrationSettings,
                              anafIntegration: e.target.checked
                            } as any)}
                          />
                        }
                        label="Integrare ANAF"
                      />
                    </Grid>
                    <Grid size={12}>
                      <FormControlLabel
                        control={
                          <Switch
                            checked={(integrationSettings as any)?.emailIntegration || false}
                            onChange={(e) => setIntegrationSettings({
                              ...integrationSettings,
                              emailIntegration: e.target.checked
                            } as any)}
                          />
                        }
                        label="Integrare email"
                      />
                    </Grid>
                  </Grid>
                </CardContent>
                <CardActions>
                  <Button
                    variant="contained"
                    startIcon={<SaveIcon />}
                    onClick={() => handleSave('integrations', integrationSettings)}
                    disabled={loading}
                  >
                    Salveaza
                  </Button>
                </CardActions>
              </Card>
            </Grid>
          </Grid>
        ) : null}
      </TabPanel>

      {/* GDPR Settings Tab */}
      <TabPanel value={activeTab} index={7}>
        {loading ? (
          <Box display="flex" justifyContent="center" p={4}>
            <CircularProgress />
          </Box>
        ) : gdprSettings ? (
          <Grid container spacing={3}>
            <Grid size={{ xs: 12, md: 6 }}>
              <Card>
                <CardContent>
                  <Typography variant="h6" gutterBottom>
                    Setari GDPR
                  </Typography>
                  <Grid container spacing={2}>
                    <Grid size={12}>
                      <FormControlLabel
                        control={
                          <Switch
                            checked={(gdprSettings as any)?.dataRetentionEnabled || false}
                            onChange={(e) => setGdprSettings({
                              ...gdprSettings,
                              dataRetentionEnabled: e.target.checked
                            } as any)}
                          />
                        }
                        label="Pastrare automata date"
                      />
                    </Grid>
                    <Grid size={{ xs: 12, sm: 6 }}>
                      <TextField
                        fullWidth
                        label="Perioada pastrare (luni)"
                        type="number"
                        value={(gdprSettings as any)?.dataRetentionPeriod || ''}
                        onChange={(e) => setGdprSettings({
                          ...gdprSettings,
                          dataRetentionPeriod: parseInt(e.target.value)
                        } as any)}
                      />
                    </Grid>
                  </Grid>
                </CardContent>
                <CardActions>
                  <Button
                    variant="contained"
                    startIcon={<SaveIcon />}
                    onClick={() => handleSave('gdpr', gdprSettings)}
                    disabled={loading}
                  >
                    Salveaza
                  </Button>
                </CardActions>
              </Card>
            </Grid>
          </Grid>
        ) : null}
      </TabPanel>

      {/* Audit Log Tab */}
      <TabPanel value={activeTab} index={8}>
        <Grid container spacing={3}>
          <Grid size={12}>
            <Card>
              <CardContent>
                <Typography variant="h6" gutterBottom>
                  Audit Log
                </Typography>
                <TableContainer>
                  <Table>
                    <TableHead>
                      <TableRow>
                        <TableCell>Data</TableCell>
                        <TableCell>Utilizator</TableCell>
                        <TableCell>Actiune</TableCell>
                        <TableCell>Detalii</TableCell>
                      </TableRow>
                    </TableHead>
                    <TableBody>
                      {auditLogs.map((log) => (
                        <TableRow key={log.id}>
                          <TableCell>{formatForDisplay(log.timestamp)}</TableCell>
                          <TableCell>{log.userName}</TableCell>
                          <TableCell>{log.action}</TableCell>
                          <TableCell>{(log as any).details || 'N/A'}</TableCell>
                        </TableRow>
                      ))}
                    </TableBody>
                  </Table>
                </TableContainer>
                <TablePagination
                  component="div"
                  count={auditTotal}
                  page={auditPage}
                  onPageChange={(e, newPage) => setAuditPage(newPage)}
                  rowsPerPage={auditRowsPerPage}
                  onRowsPerPageChange={(e) => {
                    setAuditRowsPerPage(parseInt(e.target.value, 10));
                    setAuditPage(0);
                  }}
                />
              </CardContent>
            </Card>
          </Grid>
        </Grid>
      </TabPanel>

      {/* Backup/Restore Actions */}
      <Box sx={{ position: 'fixed', bottom: 16, right: 16 }}>
        <Fab
          color="primary"
          onClick={() => setBackupDialogOpen(true)}
          sx={{ mr: 2 }}
        >
          <BackupIcon />
        </Fab>
        <Fab
          color="secondary"
          onClick={() => setRestoreDialogOpen(true)}
        >
          <RestoreIcon />
        </Fab>
      </Box>

      {/* Backup Dialog */}
      <Dialog open={backupDialogOpen} onClose={() => setBackupDialogOpen(false)}>
        <DialogTitle>Backup Setari</DialogTitle>
        <DialogContent>
          <Typography>
            Aceasta actiune va descarca un fisier JSON cu toate setarile clinicii.
          </Typography>
        </DialogContent>
        <DialogActions>
          <Button onClick={() => setBackupDialogOpen(false)}>Anuleaza</Button>
          <Button onClick={handleBackup} variant="contained">
            Descarca Backup
          </Button>
        </DialogActions>
      </Dialog>

      {/* Restore Dialog */}
      <Dialog open={restoreDialogOpen} onClose={() => setRestoreDialogOpen(false)}>
        <DialogTitle>Restore Setari</DialogTitle>
        <DialogContent>
          <input
            type="file"
            accept=".json"
            onChange={(e) => {
              const file = e.target.files?.[0];
              if (file) {
                handleRestore(file);
                setRestoreDialogOpen(false);
              }
            }}
          />
        </DialogContent>
        <DialogActions>
          <Button onClick={() => setRestoreDialogOpen(false)}>Anuleaza</Button>
        </DialogActions>
      </Dialog>
    </Box>
  );
};

export default InternalSettings;
